import dayjs, { Dayjs } from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/London")

class DateTimeConversionService {
    private shortDateFormat: string = "DD.MMM.YYYY";
    private middleDateFormat: string = "ddd DD.MMM.YYYY";
    private longDateFormat: string = "DD.MMM.YYYY HH:mm:ss";
    
    private emptyString: string = "";

    toUtcDate(value: Dayjs): Date {
        const originalTimezone = value.utcOffset();
        return value.add(originalTimezone, 'minute').toDate();
    }
    
    // toUtcDate(value: Date): Date {
    //     const convertedDate = dayjs(value);
    //     const originalTimezone = convertedDate.utcOffset();
    //
    //     return convertedDate.add(originalTimezone, 'minute').toDate();
    // }
    
    convertToUtcDate(value: Date): Dayjs {
        return dayjs(value);
    }

    convertUtcDateToDisplayDate(value: Date): Dayjs {
        return dayjs.utc(value).tz("Europe/London", true);
    }
    
    getCurrentUtcDate(): Date {
        return dayjs().toDate();
    }
    
    parseToUtcDate(value: string): Date {
        const localDate = new Date(value);
        
        const year = localDate.getFullYear();
        const month = this.convertNumberToTwoDigitFormattedString(localDate.getMonth() + 1);
        const day = this.convertNumberToTwoDigitFormattedString(localDate.getDate());
        const hours = this.convertNumberToTwoDigitFormattedString(localDate.getHours());
        const minutes = this.convertNumberToTwoDigitFormattedString(localDate.getMinutes());
        const seconds = this.convertNumberToTwoDigitFormattedString(localDate.getSeconds());
        
        return new Date(`${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`)
    }

    private convertNumberToTwoDigitFormattedString(value: number): string {
        return new Intl.NumberFormat('en-US', {
            minimumIntegerDigits: 2
        }).format(value);
    }
    
    parseToUtcDateJs(value: string): Dayjs {
        return dayjs(value);
    }
    
    parseAndConvertDateToShortFormattedString(value: string | null): string {
        if (value === null) {
            return this.emptyString;
        }
        
        return dayjs(value).format(this.shortDateFormat);
    }

    parseAndConvertDateToLongFormattedString(value: string | null): string {
        if (value === null) {
            return this.emptyString;
        }

        return dayjs(value).format(this.longDateFormat);
    }
    
    convertDateToShortFormattedString(value: Date | null | undefined): string {
        if (value === null || value === undefined) {
            return this.emptyString;
        }
        
        return dayjs(value).format(this.shortDateFormat);
    }

    convertDateToMiddleFormattedString(value: Date | null | undefined): string {
        if (value === null || value === undefined) {
            return this.emptyString;
        }

        return dayjs(value).format(this.middleDateFormat);
    }
    
    convertDateToLongFormattedString(value: Date | null | undefined): string {
        if (value === null || value === undefined) {
            return this.emptyString;
        }
        
        return dayjs(value).format(this.longDateFormat);
    }

    convertDateToCustomFormattedString(value: Date | null | undefined, format: string): string {
        if (value === null || value === undefined) {
            return this.emptyString;
        }

        return dayjs(value).format(format);
    }

    getExpirationPeriodInfoText(expirationDate: Date | null): string | null {
        if (expirationDate === null)
            return null;

        const expirationDateJs = dayjs(expirationDate);

        return expirationDateJs.diff(dateTimeConversionService.getCurrentUtcDate(), 'hours') < 48
            ? `${expirationDateJs.diff(dateTimeConversionService.getCurrentUtcDate(), 'hours')} h`
            : `${expirationDateJs.diff(dateTimeConversionService.getCurrentUtcDate(), 'days')} d`;
    }
}

export const dateTimeConversionService = new DateTimeConversionService();
